defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
  [
    'Shared/Framework/Mithril/Scripts/Helpers/ApiRequest',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils'
  ],
  function (ApiRequest, Dictionary, Utils) {

    var d = Dictionary.get.bind({ prefix: 'ErrorMessages/' });

    // Variables:
    var basePlayTogetherURL = '/dlo/scapi/danskespil/numbergames';

    // Functions:
    var createClub = function (data) {
      data.name = data.clubName;
      data.theme = {
        background: data.theme.background() ? data.theme.background().id : null,
        badge: data.theme.badge() ? data.theme.badge().id : null,
        badgeBackground: data.theme.badgeBackground() ? data.theme.badgeBackground().id : null,
        colorTheme: data.theme.colorTheme() ? data.theme.colorTheme().id : null
      };
      return ApiRequest({
        method: 'POST',
        url: basePlayTogetherURL + '/groupplay/groups',
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var deleteClub = function (clubId) {
      return ApiRequest({
        method: 'DELETE',
        url: basePlayTogetherURL + '/groupplay/groups/' + clubId,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var getClub = function (id, data) {
      return ApiRequest({
        url: basePlayTogetherURL + '/groupplay/groups/' + id,
        data: data,
        unwrapError: unwrapError
      });
    };

    var updateClub = function (clubId, data) {
      data.name = data.clubName;
      data.theme = {
        background: data.theme.background() ? data.theme.background().id : null,
        badge: data.theme.badge() ? data.theme.badge().id : null,
        badgeBackground: data.theme.badgeBackground() ? data.theme.badgeBackground().id : null,
        colorTheme: data.theme.colorTheme() ? data.theme.colorTheme().id : null
      };
      return ApiRequest({
        data: data,
        method: 'PUT',
        url: basePlayTogetherURL + '/spilsammen/clubs/' + clubId,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var getAllClubs = function (data, forceLogin) {
      return ApiRequest({
        url: basePlayTogetherURL + '/groupplay/groups',
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: forceLogin ? unwrapError : null
      });
    };

    var getAllClubMembers = function (id) {
      return ApiRequest({
        url: basePlayTogetherURL + '/groupplay/groups/' + id + '/players',
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var getInvitationDetails = function (id, data) {
      return ApiRequest({
        url: basePlayTogetherURL + '/groupplay/invite/inviteGroup/' + id,
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        // User may not be in logged in at this state and so, this does not use the general unwrapError function
        unwrapError: function (response) {
          return getErrorKey(response);
        }
      });
    };

    var acceptInvitation = function (id, data) {
      return ApiRequest({
        method: 'POST',
        url: basePlayTogetherURL + '/groupplay/groups/' + id + '/players',
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var getUserPlays = function (data) {
      return ApiRequest({
        url: basePlayTogetherURL + '/groupplay/plays',
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var createPlay = function (clubId, data) {
      return ApiRequest({
        method: 'POST',
        url: basePlayTogetherURL + '/groupplay/groups/' + clubId + '/plays',
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var fundPlay = function (clubId, playId, data) {
      return ApiRequest({
        method: 'POST',
        url: basePlayTogetherURL + '/groupplay/groups/' + clubId + '/plays/' + playId + '/fund',
        data: data,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var deletePlay = function (clubId, playId) {
      return ApiRequest({
        method: 'DELETE',
        url: basePlayTogetherURL + '/groupplay/groups/' + clubId + '/plays/' + playId,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var removePlayer = function (clubId, playerId) {
      if (!playerId) {
        return ApiRequest({
          method: 'DELETE',
          url: basePlayTogetherURL + '/groupplay/groups/' + clubId + '/players',
          unwrapSuccess: function (response) {
            return response;
          },
          unwrapError: unwrapError
        });
      }

      return ApiRequest({
        method: 'DELETE',
        url: basePlayTogetherURL + '/groupplay/groups/' + clubId + '/players/' + playerId,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var makePlayerChairman = function (clubId, playerId) {
      return ApiRequest({
        method: 'PUT',
        url: basePlayTogetherURL + '/groupplay/groups/' + clubId + '/chairman',
        data: {
          PlayerId: playerId
        },
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var getSubscribeReminder = function (brand) {
      return ApiRequest({
        method: 'GET',
        url: basePlayTogetherURL + '/groupplay/reminder/subscribeReminder?brand=' + brand
      });
    };

    var setSubscribeReminder = function (subscribe, brand) {
      return ApiRequest({
        method: 'POST',
        url: basePlayTogetherURL + '/groupplay/reminder/subscribeReminder?subscribe=' + subscribe + '&brand=' + brand
      });
    };

    var getRandomClubName = function () {
      return ApiRequest({
        method: 'GET',
        url: basePlayTogetherURL + '/spilsammen/name/random'
      });
    };

    var validateClubName = function (name) {
      return ApiRequest({
        method: 'POST',
        url: basePlayTogetherURL + '/spilsammen/name/validation',
        data: { name: name },
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    var getPersonalizationOptions = function () {
      return ApiRequest({
        method: 'GET',
        url: basePlayTogetherURL + '/spilsammen/themes'
      });
    };

    const getClubCoupons = (clubId) => {
      let url = `/api/numbergames/couponcheck/v1/groupPlays?groupId=${clubId}&includeGameInformation=true`;

      if (DS.Config.ENV === 'dev') {
        url = `${DS.Config.LOGINPAGE_HOST}${url}`;
      }

      return ApiRequest({
        method: 'GET',
        url: url,
        withCredentials: true,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    const getQRCode = (clubId) => {
      return ApiRequest({
        method: 'GET',
        url: `${basePlayTogetherURL}/groupplay/invite/invitegroup/${clubId}/qr`,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: unwrapError
      });
    };

    const validateGroupSubscriptionConflict = (subscriptionGroupGameId) => {
      return ApiRequest({
        method: 'GET',
        withCredentials: true,
        url: `/dlo/scapi/danskespil/subscriptions/groups/validate-conflict?subscriptionGroupGameId=${subscriptionGroupGameId}`,
        unwrapSuccess: function (response) {
          return response;
        },
        unwrapError: (response, xhr) => {
          Utils.checkLoginStatus();

          if (xhr.status !== 409) {
            return unwrapError(response);
          }

          return {
            errorCode: response.errorCode,
            affectedSubscriptionId: response.additionalInfo
          };
        }
      });
    };

    var unwrapError = function (response) {
      Utils.checkLoginStatus();

      //  Show error message to page UI
      return getErrorKey(response);
    };

    var getErrorKey = function (response) {
      var genericErrorMessage = d('GENERIC_ERROR');

      if ((!response || !response.errorMessage) && genericErrorMessage) {
        return genericErrorMessage;
      }

      var errorKey = response.errorMessage.split('.').pop();
      var errorMessage = d(errorKey);

      return typeof errorMessage === 'string' ? errorMessage : genericErrorMessage;
    };

    // Public functions:
    return {
      createClub: createClub,
      deleteClub: deleteClub,
      getClub: getClub,
      updateClub: updateClub,
      getAllClubs: getAllClubs,
      getAllClubMembers: getAllClubMembers,
      getInvitationDetails: getInvitationDetails,
      acceptInvitation: acceptInvitation,
      getUserPlays: getUserPlays,
      createPlay: createPlay,
      deletePlay: deletePlay,
      fundPlay: fundPlay,
      removePlayer: removePlayer,
      makePlayerChairman: makePlayerChairman,
      setSubscribeReminder: setSubscribeReminder,
      getSubscribeReminder: getSubscribeReminder,
      getRandomClubName: getRandomClubName,
      getPersonalizationOptions: getPersonalizationOptions,
      validateClubName: validateClubName,
      getClubCoupons: getClubCoupons,
      getQRCode: getQRCode,
      validateGroupSubscriptionConflict: validateGroupSubscriptionConflict,
    };

  });
